import { useState } from 'react';
import { deleteColaborador } from '../../services/colaboradorService';

const useDeleteColaborador = () => {
    const [loadingDeleteColaborador, setLoadingDeleteColaborador] = useState(false);
    const [errorDeleteColaborador, setErrorDeleteColaborador] = useState<string | null>(null);

    const handleDeleteColaborador = async (id: string): Promise<boolean> => {
        setLoadingDeleteColaborador(true);
        setErrorDeleteColaborador(null);
        try {
            await deleteColaborador(id);
            return true;
        } catch (error) {
            setErrorDeleteColaborador('Erro ao deletar colaborador');
            return false;
        } finally {
            setLoadingDeleteColaborador(false);
        }
    };

    return { handleDeleteColaborador, loadingDeleteColaborador, errorDeleteColaborador };
};

export default useDeleteColaborador;
